module.exports = __webpack_public_path__ + "media/ים.0ff28b56.mp3";